<template>
  <div class="empty-message">
    <div class="empty-message__container">
      <div class="empty-message__container__icon">
        <md-icon md-src="/static/images/icon-happyface.svg" />
      </div>
      <div class="empty-message__container__message">
        Sem mais {{ type }} por enquanto.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyMessage',
  props: {
    type: String
  }
}
</script>

<style lang="scss">
.empty-message {
  display: none;
  flex-wrap: wrap;
  width: 90%;
  float: right;
  margin-bottom: 60px;
  z-index: 100;
  background-color: #f4f4f4;
  position: relative;

  &__container {
    padding: 40px;
    display: flex;
    color: #d0d0d0;
    margin: auto 0;
    width: 100%;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    font-weight: 600;
    align-items: center;
    justify-content: center;

    &__icon {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }

    &__message {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
